export const required = (value) => {
    return !!value;
};

export const matchType = (type) => {
    return (value) => {
        return typeof value === type;
    };
};

export const checkAnyEquals = (fields = [], valueToCheck) => {
    return (value, values) => {
        return fields.findIndex(item => values[item] === valueToCheck) !== -1;
    }
}

export const greaterThan = (field1, field2) => (value, values) => values[field1] > values[field2]



export const validateEmail = (value) => { };

export const matchLength = (length) => {
    return (value) => {
        return value.length === length;
    };
};

export const minLength = (length) => {
    return (value) => {
        return value.length >= length;
    };
};

export const matchRegex = (pattern) => {
    return (value) => {
        const patt = new RegExp(pattern);
        return patt.test(value);
    };
};

export const validatePasswordConfirm = (passwordConfirm, values) => {
    const password = values.password;
    return password === passwordConfirm;
};

export const runValidators = (value, validate, values) => {
    const validators = Array.isArray(validate) ? validate : [validate];

    for (const { validator, message } of validators) {
        const valid = validator(value, values);
        if (typeof valid !== 'boolean') {
            return valid;
        } else if (!valid) {
            return message ? message : !valid;
        }
    }
    return null;
};